"use strict";

import React from "react";

import AppColors from "../constants/AppColors";
import DesignSaveStore from "../stores/DesignSaveStore";

import Glyphicon from "./base/Glyphicon";
import ProcessingIndicator from "./utils/ProcessingIndicator";
import AppConfig from "../config/app";
import { Icon } from "@showitinc/showit-wc";
import styles from "./DesignSaveStatus.module.css";

class DesignSaveStatus extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      inSync: DesignSaveStore.getState(),
    };

    this._onDesignSaveChange = this._onDesignSaveChange.bind(this);
  }

  componentDidMount() {
    this.storeUnsubscribe = DesignSaveStore.listen(this._onDesignSaveChange);
  }

  componentWillUnmount() {
    this.storeUnsubscribe();
  }

  _onDesignSaveChange(inSync) {
    this.setState({ inSync: inSync });
  }

  render() {
    if (AppConfig.demoMode) {
      return null;
    }

    let status = null;
    if (this.state.inSync) {
      status = (
        <div className={`${styles["save-status"]} ${styles["saved"]}`}>
          <Icon type="check" size="20" /> Saved
        </div>
      );
    } else {
      status = (
        <div className={styles["save-status"]}>
          <ProcessingIndicator
            color="var(--text-base-primary)"
            size="6"
            delay=".25"
            speed="1.25s"
            dots="3"
          />
        </div>
      );
    }

    return status;
  }
}

export default DesignSaveStatus;
